<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="tabs__row">
        <div class="field">{{ $t("registration.training_info.general_info.institution_name") }}</div>
        <div class="text">
          {{ training.institution ? training.institution.name : "" }}
          <span v-if="training.component?.name"> - {{ training.component.name }}</span>
        </div>
      </div>
      <div class="tabs__row">
        <div class="field">{{ $t("registration.training_info.general_info.reference") }}</div>
        <div class="text">{{ training.reference }}</div>
      </div>
      <div class="tabs__row">
        <div class="field">{{ $t("registration.training_info.general_info.rncp_number") }}</div>
        <div class="text">
          {{ training.titleRncp ? training.titleRncp.code : "" }}
        </div>
      </div>
      <div class="tabs__row">
        <div class="field">{{ $t("registration.training_info.general_info.offical_name") }}</div>
        <div class="text">
          {{ training?.titleRncp?.name ? training.titleRncp.name : "" }}
        </div>
      </div>
      <div class="tabs__row">
        <div class="field">{{ $t("registration.training_info.general_info.diplome_type") }}</div>
        <div class="text">
          {{ training.degree ? training.degree.name : "" }}
        </div>
      </div>
      <div class="tabs__row">
        <div class="field">{{ $t("registration.training_info.general_info.mention") }}</div>
        <div class="text">
          {{ training.name }}
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="tabs__row">
        <div class="field">{{ $t("registration.training_info.general_info.status") }}</div>
        <div class="text">
          <span
            class="badge"
            :class="{
              'bg-success': !training.archive,
              'bg-danger': training.archive,
            }"
            >{{
              training.archive
                ? $t("registration.training_info.general_info.archived")
                : $t("registration.training_info.general_info.active")
            }}</span
          >
        </div>
      </div>
      <div class="tabs__row">
        <div class="field">{{ $t("registration.training_info.general_info.logo") }}</div>
        <div class="text">
          <img v-if="logo" :src="logo" :alt="training.name" class="tabs__logo" />
        </div>
      </div>
      <div class="tabs__row">
        <div class="field">{{ $t("registration.training_info.general_info.work_study_duration") }}</div>
        <div class="text">{{ training.duration }} {{ $t("Month").toLowerCase() }}</div>
      </div>
      <div class="tabs__row">
        <div class="field">{{ $t("registration.training_info.general_info.total_cycle_time") }}</div>
        <div class="text">{{ training.duration }} {{ $t("Month").toLowerCase() }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrainingGeneralInfoComponent",
  components: {},
  props: {
    training: {
      type: Object,
      required: true,
    },
    logo: {
      type: String,
      required: false,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  &__row {
    padding: 8px 0;
    display: flex;
    font-size: 14px;
    align-items: center;
    min-height: 40px;

    .field {
      width: 35%;
      font-weight: 600;
      @include up-to-md {
        width: 50%;
      }
    }

    .text {
      width: 65%;
      @include up-to-md {
        width: 50%;
      }
    }

    img {
      width: 100%;
      max-width: 100%;
    }
  }

  &__triads {
    margin-top: 1rem;
    border: 1px dashed $m-color_6;
    border-radius: $radius;
    padding: 1rem;
    max-height: 400px;
    overflow: auto;
    height: 100%;

    .triad {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 0;
    }

    .triad + .triad {
      border-top: 1px dashed $m-color_6;
    }
  }

  &__logo {
    max-height: 50px;
    width: initial !important;
  }
}

.tabs__row + .tabs__row {
  border-top: 1px dashed $m-color_6;
}
</style>
